module.exports = __webpack_public_path__ + "img/wave-footer.9e17e2cc.svg";